(function() {
    window.c24.lp.ac.mkv = {

        init: function() {
        },
    };

    const oNumberMaskOptions = {
        mask: Number, // enable number mask

        // other options are optional with defaults below
        scale: 0, // digits after point, 0 for integers
        signed: true, // disallow negative
        thousandsSeparator: '.', // any single char
        padFractionalZeros: false, // if true, then pads zeros at end to the length of scale
        normalizeZeros: true, // appends or removes zeros at ends
        radix: ',', // fractional delimiter
        mapToRadix: [''], // symbols to process as radix

        // additional number interval options (e.g.)
        min: 0,
        max: 1000000,
    };
    const elements = document.querySelectorAll('.mod24ac.mkv .widget');

    for (let i = 0; i < elements.length; i++) {

        let el = elements[i];

        setTimeout(function() {
            let sDefaultValue = el.getElementsByClassName('js24InputDepositAmount')[0]?.value;

            if (sDefaultValue === 'undefined') {
                return false;
            }

            if (!sDefaultValue) {
                sDefaultValue = '1500';
            }

            new window.Vue({
                el: el,
                data: {
                    sNumberValue: sDefaultValue,
                    oNumberMask: oNumberMaskOptions,
                    oUrlParamDepositAmount: null,
                },
                directives: {
                    imask: window.VueIMask.IMaskDirective,
                },
                mounted: function () {

                    window.c24LpInitializeFixables(this.$el.closest('.mod24ac'));

                    if (!window.c24LpIsMobile) {
                        window.c24.lp.ac.initGenericTooltips('mkv');
                    }

                    this.oUrlParamDepositAmount = this.$el.getElementsByClassName('js24ParamDepositAmount')[0];

                    if (this.oUrlParamDepositAmount) {
                        const form = this.$el.getElementsByTagName('form')[0];
                        form.addEventListener('submit', function() {
                            if (!this.oUrlParamDepositAmount.value) {
                                this.oUrlParamDepositAmount.value = sDefaultValue;
                            }
                        }.bind(this), false);
                    }

                },
                methods: {
                    onComplete: function(e) {
                        if (this.oUrlParamDepositAmount) {
                            this.oUrlParamDepositAmount.value = e.detail.unmaskedValue;
                        }
                    },
                },
            });
        }, 0);
    }

    $(document).ready(function() {
        window.c24.lp.ac.mkv.init();
    });
})();
